/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Button,
  Row,
  Col,
  Grid,
} from 'react-bootstrap';
import SearchInput from 'loracoms/SearchInput';
import IntlMsg from 'lorautils/intl/IntlMsg';
import gatewayActions from 'loraactions/gateway';
import deviceActions from 'loraactions/device';
import appActions from 'loraactions/app';
import {
  normalizeAppEUI,
  normalizeMac,
  normalizeDevEUI,
} from 'lorautils/IdUtils';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  onHide: React.PropTypes.func.isRequired,
  getApps: React.PropTypes.func.isRequired,
  getDevices: React.PropTypes.func.isRequired,
  getGateways: React.PropTypes.func.isRequired,
  apps: React.PropTypes.object.isRequired,
  devices: React.PropTypes.object.isRequired,
  gateways: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
};


class SearchOverlay extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      apps: props.apps,
      devices: props.devices,
      gateways: props.gateways,
    };
    this.intlMsg = new IntlMsg(props.intl, 'overview.search');
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { apps, devices, gateways } = nextProps;
    if (apps !== this.props.apps) {
      this.setState({ apps });
    }
    if (devices !== this.props.devices) {
      this.setState({ devices });
    }
    if (gateways !== this.props.gateways) {
      this.setState({ gateways });
    }
  }

  handleSearch(e) {
    const { getApps, getDevices, getGateways } = this.props;
    const q = e.target.value;

    this.setState({
      searchQ: q,
    });

    const doSearch = () => {
      const qq = q.replace(/[-:]/g, '');
      getApps({ q: `or,name:*${q}*,APPEUI:*${qq}*` });
      getGateways({ q: `or,name:*${q}*,id:*${qq}*` });
      getDevices({ q: `or,name:*${q}*,deveui:*${qq}*,devaddr:*${qq}*` });
    };

    if (q.length > 0) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(doSearch, 300);
    }
  }

  handleOnHide() {
    const { onHide, getApps } = this.props;
    getApps({ count: true, tkcnt: true });
    onHide();
  }
  renderList(result, major, sub, itemLink, moreLink) {
    const { pushState } = this.props;
    const { searchQ = '' } = this.state;
    if (searchQ === '') {
      return [];
    }

    const loading = (
      <div className={`text-center ${styles.loading}`}>
        <i className="fa fa-spinner fa-spin fa-3x" />
      </div>
    );

    const { status, data } = result;

    if (status === 'pending') {
      return loading;
    }
    if (status === 'success') {
      const list = data.list.map((item, idx) => (
        <li key={idx}>
          <Link onClick={() => pushState(itemLink(item))}>
            <div className={`${styles.item}`}>
              <div className={styles.major}>{major(item) || sub(item)}</div>
              <div className={styles.sub}>{sub(item)}</div>
            </div>
          </Link>
        </li>
      ));
      list.push((
        <li key={'more'} className="text-center">
          <Button
            bsStyle="aisz-link-default"
            onClick={() => pushState(moreLink)}
          >
            {this.intlMsg.msg('seemore')}
          </Button>
        </li>
      ));
      return <ul className="list-unstyled">{list}</ul>;
    }

    return null;
  }

  renderResult() {
    const { apps, devices, gateways } = this.state;

    return (
      <Grid fluid>
        <Row>
          <Col md={4} className={styles.gateway}>
            <h2>{this.intlMsg.msg('gateways')}</h2>
            {
              this.renderList(
                gateways,
                x => x.name,
                x => normalizeMac(x.mac),
                x => `/gateway/detail/${x.id}`,
                '/gateway')
            }
          </Col>
          <Col md={4} className={styles.app}>
            <h2>{this.intlMsg.msg('apps')}</h2>
            {
              this.renderList(
                apps,
                x => x.name,
                x => normalizeAppEUI(x.appeui),
                x => `/application/${x.id}`,
                '/application')
            }
          </Col>
          <Col md={4} className={styles.device}>
            <h2>{this.intlMsg.msg('devices')}</h2>
            {
              this.renderList(
                devices,
                x => x.name,
                x => normalizeDevEUI(x.deveui),
                x => `/application/${x.appeui}/devices/${x.id}`,
                '/application')
            }
          </Col>
        </Row>
      </Grid>
    );
  }

  render() {
    const { searchQ = '' } = this.state;

    return (
      <ReactCSSTransitionGroup
        transitionName={{
          enter: styles.overlayEnter,
          enterActive: styles.overlayEnterActive,
          leave: styles.overlayLeave,
          leaveActive: styles.overlayLeaveActive,
          appear: styles.overlayAppear,
          appearActive: styles.overlayAppearActive,
        }}
        transitionAppear
        transitionAppearTimeout={300}
        transitionEnterTimeout={300}
        transitionLeaveTimeout={100}
      >
        <div className={styles.overlay} key="overlay">
          <div className={styles.closeButton}>
            <Button bsStyle="aisz-link-default" onClick={() => this.handleOnHide()}>
              <span className="glyphicons glyphicons-remove" />
            </Button>
          </div>
          <div className={styles.content}>
            <div className={styles.search}>
              <SearchInput
                placeholder={this.intlMsg.msg('placeholder')}
                value={searchQ}
                onChange={this.handleSearch}
                autoFocus
              />
            </div>
            <div className={styles.result}>
              {this.renderResult()}
            </div>
          </div>
        </div>
      </ReactCSSTransitionGroup>
    );
  }
}

SearchOverlay.propTypes = propTypes;


const mapStateToProps = state => ({
  apps: state.app.getApps,
  devices: state.device.getDevices,
  gateways: state.gateway.getGateways,
});

const mapDispatchToProps = {
  getApps: appActions.getApps,
  getDevices: deviceActions.getDevices,
  getGateways: gatewayActions.getGateways,
  pushState: routerActions.push,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SearchOverlay));




// WEBPACK FOOTER //
// ./src/containers/Overview/SearchOverlay/index.jsx